(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7945],{

/***/ 40352:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-originals",
      function () {
        return __webpack_require__(33317);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAccountManageWallet; }
/* harmony export */ });
/* harmony import */ var _useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18060);

var useAccountManageWallet = (0,_useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageDependentDataSSr */ .Y)("account-manage-wallet");


/***/ }),

/***/ 64350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48318);
/* harmony import */ var react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_multi_carousel_lib_styles_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_multi_carousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86529);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63367);
/* harmony import */ var _themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _carousel_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72132);
/* harmony import */ var _carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var CarouselComponent = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(props.className || "", " ").concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["carousel-wrapper"]), " ").concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[props.type]),
        "data-testid": "carousel-component",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_multi_carousel__WEBPACK_IMPORTED_MODULE_3__["default"], {
            additionalTransfrom: 0,
            arrows: props.items && props.items.length > 1,
            autoPlaySpeed: 3000,
            autoPlay: props.items && props.items.length > 1,
            centerMode: false,
            containerClass: "".concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["carousel-container"])),
            dotListClass: "".concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["carousel-dots"]), " ").concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default())["".concat(props.inverted && "inverted")]),
            draggable: props.items && props.items.length > 1,
            focusOnSelect: false,
            infinite: true,
            itemClass: "".concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["carousel-item"])),
            keyBoardControl: true,
            minimumTouchDrag: 80,
            renderButtonGroupOutside: false,
            renderDotsOutside: true,
            responsive: {
                desktop: {
                    breakpoint: {
                        max: 8192,
                        min: Number(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().desktopSmall.slice(0, -2))
                    },
                    items: 1
                },
                mobile: {
                    breakpoint: {
                        max: Number(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mobile.slice(0, -2)),
                        min: 0
                    },
                    items: 1
                },
                tablet: {
                    breakpoint: {
                        max: Number(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().desktopSmall.slice(0, -2)),
                        min: Number(_themes_variables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mobile.slice(0, -2))
                    },
                    items: 1
                }
            },
            sliderClass: "".concat((_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["carousel-sliderClass"])),
            showDots: props.items && props.items.length > 1,
            slidesToSlide: 1,
            swipeable: props.items && props.items.length > 1,
            partialVisible: true,
            children: props.items.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_carousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item),
                    children: item
                }, index);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselComponent);


/***/ }),

/***/ 93659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stage_image_background; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/default_header.jpg
/* harmony default export */ var default_header = ({"src":"/_next/static/media/default_header.e80958d5.jpg","height":775,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAACAgIDAAAAAAAAAAAAAAABAgADBAURE9H/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABYRAAMAAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8AhbbNutDM60kgqOehPIiJSoE6f//Z"});
// EXTERNAL MODULE: ./src/utils/_hooks/useWindowSize.hook.ts
var useWindowSize_hook = __webpack_require__(29486);
// EXTERNAL MODULE: ./src/components/_shared/stage-image-background/stage-image-background.module.scss
var stage_image_background_module = __webpack_require__(48106);
var stage_image_background_module_default = /*#__PURE__*/__webpack_require__.n(stage_image_background_module);
;// CONCATENATED MODULE: ./src/components/_shared/stage-image-background/stage-image-background.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var StageImageBackground = function(props) {
    var ref = _slicedToArray((0,useWindowSize_hook/* default */.Z)(), 1), width = ref[0];
    var _url;
    return width ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        className: "".concat((stage_image_background_module_default())["stage-background"], " ").concat(props.className ? props.className : ""),
        src: (_url = props.url) !== null && _url !== void 0 ? _url : default_header.src,
        alt: props.alt,
        layout: "fill",
        sizes: width > 1920 ? "100vw" : "1920px",
        objectPosition: props.objectPosition,
        objectFit: "cover",
        priority: true
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
};
/* harmony default export */ var stage_image_background = (StageImageBackground);
StageImageBackground.defaultProps = {
    objectPosition: "top"
};


/***/ }),

/***/ 33317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_digital_originals; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/hooks/useAccountManageWallet.hook.ts
var useAccountManageWallet_hook = __webpack_require__(93165);
// EXTERNAL MODULE: ./src/api/hooks/useContextSSr.hook.ts
var useContextSSr_hook = __webpack_require__(63794);
// EXTERNAL MODULE: ./src/api/hooks/useLanguageDependentDataSsr.hook.ts
var useLanguageDependentDataSsr_hook = __webpack_require__(18060);
;// CONCATENATED MODULE: ./src/api/hooks/useDigitalOriginalsPage.hook.ts

var useDigitalOriginalsPage = (0,useLanguageDependentDataSsr_hook/* useLanguageDependentDataSSr */.Y)("digital-originals-page");

// EXTERNAL MODULE: ./src/api/hooks/useLoginPage.hook.ts
var useLoginPage_hook = __webpack_require__(92534);
// EXTERNAL MODULE: ./src/components/_shared/header/default-header/default-header.tsx + 9 modules
var default_header = __webpack_require__(4302);
// EXTERNAL MODULE: ./src/components/_shared/header-footer-wrapper/header-footer-wrapper.tsx
var header_footer_wrapper = __webpack_require__(3143);
// EXTERNAL MODULE: ./src/components/_shared/meta-tags-resolver/meta-tags-resolver.tsx
var meta_tags_resolver = __webpack_require__(66743);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/utils/_enums/basic-card-variants.enum.ts
var basic_card_variants_enum = __webpack_require__(90017);
// EXTERNAL MODULE: ./src/utils/_enums/filter-expression.enum.tsx
var filter_expression_enum = __webpack_require__(55190);
// EXTERNAL MODULE: ./src/utils/_helper/time-helper.tsx
var time_helper = __webpack_require__(28508);
// EXTERNAL MODULE: ./src/utils/_hooks/hooks.tsx
var hooks = __webpack_require__(62251);
// EXTERNAL MODULE: ./src/components/_shared/teaser/teaser.tsx + 1 modules
var teaser = __webpack_require__(10725);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card/teaser-card.tsx + 17 modules
var teaser_card = __webpack_require__(33076);
;// CONCATENATED MODULE: ./src/components/digital-originals/coming-soon-teaser/coming-soon-teaser.tsx











var ComingSoonTeaser = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var data1 = useDigitalOriginalsPage();
    var variants = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.productSlice.comingSoonVariants;
    });
    (0,react.useEffect)(function() {
        fetchVariants(variants.pagination.page, 6);
    }, []);
    var fetchVariants = function(offset, pageSize) {
        dispatch((0,redux/* fetchComingSoonVariants */.dN)([
            {
                value: pageSize.toString(),
                param: "size",
                comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
            },
            {
                value: offset.toString(),
                param: "offset",
                comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
            },
            {
                value: encodeURIComponent((0,time_helper/* dateToISOString */.CI)(new Date())),
                param: "saleFrom",
                comparisonType: filter_expression_enum/* FilterExpression.greaterThan */.p.greaterThan
            },
            {
                param: "sort",
                comparisonType: filter_expression_enum/* FilterExpression.none */.p.none,
                value: "salesAttribute.saleFrom,asc"
            }
        ]));
    };
    if (data1 && (variants === null || variants === void 0 ? void 0 : variants.data) && variants.data.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser/* default */.Z, {
                headline: data1.comingSoonHeadline.headlineContent,
                maxCards: variants.maxNumber,
                headlineElement: "h2",
                initialCardIndex: variants.pagination.page,
                pending: variants.pending,
                cards: variants.data.map(function(variant) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card/* default */.Z, {
                        variant: variant
                    }, "future-variant-".concat(variant.id));
                }),
                type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_SMALL */.I.BASIC_CARD_SMALL,
                onLoadNewItems: function(data) {
                    fetchVariants(data.pageOrOffset, data.size);
                }
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var coming_soon_teaser = (ComingSoonTeaser);

// EXTERNAL MODULE: ./src/assets/icons/creatoken.svg.tsx
var creatoken_svg = __webpack_require__(43301);
// EXTERNAL MODULE: ./src/utils/_enums/sales-type.tsx
var sales_type = __webpack_require__(9943);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/utils/_helper/creatoken-posterUrl-resolver.ts
var creatoken_posterUrl_resolver = __webpack_require__(70808);
// EXTERNAL MODULE: ./src/utils/_helper/enum-to-language-mapper.tsx
var enum_to_language_mapper = __webpack_require__(15487);
// EXTERNAL MODULE: ./src/utils/_helper/generate-url-to-details-page-helper.ts
var generate_url_to_details_page_helper = __webpack_require__(49352);
// EXTERNAL MODULE: ./src/utils/_helper/strapi-mapper.tsx
var strapi_mapper = __webpack_require__(962);
// EXTERNAL MODULE: ./src/components/_shared/basic-card/basic-card.tsx + 2 modules
var basic_card = __webpack_require__(40708);
// EXTERNAL MODULE: ./src/components/_shared/carousel/carousel.tsx
var carousel = __webpack_require__(64350);
// EXTERNAL MODULE: ./src/components/_shared/stage-image-background/stage-image-background.tsx + 1 modules
var stage_image_background = __webpack_require__(93659);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/api/hooks/useCardText.hook.ts
var useCardText_hook = __webpack_require__(14375);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-footer/teaser-card-footer.tsx
var teaser_card_footer = __webpack_require__(67396);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-text/teaser-card-text.tsx
var teaser_card_text = __webpack_require__(33997);
// EXTERNAL MODULE: ./src/components/_shared/variant-card/variant-card.module.scss
var variant_card_module = __webpack_require__(35890);
var variant_card_module_default = /*#__PURE__*/__webpack_require__.n(variant_card_module);
;// CONCATENATED MODULE: ./src/components/_shared/variant-card/variant-card.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var VariantCard = function(props) {
    var data = (0,useCardText_hook/* useCardText */.G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((variant_card_module_default())["variant-card-wrapper"], " ").concat((variant_card_module_default())["".concat(props.type ? props.type : "")]),
        children: [
            props.text.copies && props.text.copies > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (variant_card_module_default())["optional-info"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    variant: typeography_variants_enum/* TypographyVariantsEnum.TOPLINE_OR_LABEL */.H.TOPLINE_OR_LABEL,
                    inverted: props.inverted,
                    children: "".concat(props.text.copies, " ").concat(props.text.copies === 1 ? data === null || data === void 0 ? void 0 : data.copy : data === null || data === void 0 ? void 0 : data.copies)
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (variant_card_module_default())["teaser-card-text"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_text/* default */.Z, _objectSpread({}, props.text, {
                    variant: props.type,
                    inverted: props.inverted,
                    redirectUrl: props.redirectUrl
                }))
            }),
            props.footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_footer/* default */.Z, _objectSpread({}, props.footer, {
                inverted: props.inverted,
                type: props.type,
                redirectUrl: props.redirectUrl,
                onInformation: props.footer.onPrimaryAction && props.footer.actionType === "INFORMATION" ? props.footer.onPrimaryAction : undefined,
                onMoreInfoAndBuy: props.footer.onPrimaryAction && props.footer.actionType === "INFORMATION_AND_BUY" ? props.footer.onPrimaryAction : undefined
            }))
        ]
    });
};
/* harmony default export */ var variant_card = (VariantCard);

// EXTERNAL MODULE: ./src/components/digital-originals/digital-originals-stage/digital-originals-stage.module.scss
var digital_originals_stage_module = __webpack_require__(99375);
var digital_originals_stage_module_default = /*#__PURE__*/__webpack_require__.n(digital_originals_stage_module);
;// CONCATENATED MODULE: ./src/components/digital-originals/digital-originals-stage/digital-originals-stage.tsx




















var DigitalOriginalsStage = function(param) {
    var title = param.title, titleVariant = param.titleVariant, titleElement = param.titleElement, background = param.background, inverted = param.inverted;
    var ref6, ref1, ref2;
    var variants = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.productSlice.featuredVariants;
    });
    var ref3 = (0,react.useState)([]), filteredVariants = ref3[0], setFilteredVariants = ref3[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch((0,redux/* fetchFeaturedVariants */.gO)());
    }, []);
    (0,react.useEffect)(function() {
        if (variants === null || variants === void 0 ? void 0 : variants.data) {
            var ref;
            setFilteredVariants(variants === null || variants === void 0 ? void 0 : (ref = variants.data) === null || ref === void 0 ? void 0 : ref.filter(function(variant) {
                return variant.displayedWhenFeatured === true;
            }));
        }
    }, [
        variants
    ]);
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (digital_originals_stage_module_default()).stage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stage_image_background/* default */.Z, {
                url: background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (digital_originals_stage_module_default())["stage-content"],
                children: [
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (digital_originals_stage_module_default()).title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                            variant: titleVariant ? (0,strapi_mapper/* mapStrapiHeadline */.z)(titleVariant) : typeography_variants_enum/* TypographyVariantsEnum.HEADING1 */.H.HEADING1,
                            element: titleElement ? titleElement : "h1",
                            className: inverted ? (digital_originals_stage_module_default()).inverted : "",
                            children: title
                        })
                    }) : undefined,
                    filteredVariants.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, {
                        type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_HORIZONTAL_SMALL */.I.BASIC_CARD_HORIZONTAL_SMALL,
                        items: (ref4 = variants === null || variants === void 0 ? void 0 : (ref6 = variants.data) === null || ref6 === void 0 ? void 0 : (ref1 = ref6.map) === null || ref1 === void 0 ? void 0 : ref1.call(ref6, function(variant) {
                            var ref, ref7, ref8, ref9, ref10;
                            var _id;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_card/* default */.Z, {
                                media: {
                                    mediaUrl: (ref = variant.coverArt) === null || ref === void 0 ? void 0 : ref.url,
                                    initialLoad: true,
                                    contentType: (ref7 = variant.coverArt) === null || ref7 === void 0 ? void 0 : ref7.contentContentType,
                                    profilePictureUrl: variant.originatorsIds && variant.originatorsIds.length > 0 ? variant.originatorsIds[0] : undefined,
                                    posterUrl: (0,creatoken_posterUrl_resolver/* creatokenPosterUrlResolver */.m)((_id = variant.id) !== null && _id !== void 0 ? _id : -1),
                                    isTeaser: true
                                },
                                category: enum_to_language_mapper/* EnumToLanguageMapper.categoryIdToCategoryEnum */.H.categoryIdToCategoryEnum(variant.categoryId),
                                type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_HORIZONTAL_SMALL */.I.BASIC_CARD_HORIZONTAL_SMALL,
                                redirectUrl: (0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)(variant.productName, variant.title, variant.productId, variant.id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(variant_card, {
                                    variantId: variant.id,
                                    text: {
                                        headline: variant.title,
                                        topline: variant.originatorsNames ? variant.originatorsNames[0] : "",
                                        description: variant.variantDescriptionShort
                                    },
                                    footer: {
                                        onPrimaryAction: function() {
                                            return undefined;
                                        },
                                        actionType: variant.purchasableInstances > 0 || ((ref8 = variant.salesAttribute) === null || ref8 === void 0 ? void 0 : ref8.salesType) === sales_type/* SalesType.T_DROP */.r.T_DROP && !(0,time_helper/* isDateInPast */.OF)((ref9 = variant.salesAttribute) === null || ref9 === void 0 ? void 0 : ref9.saleTo) && (0,time_helper/* isDateInPast */.OF)((ref10 = variant.salesAttribute) === null || ref10 === void 0 ? void 0 : ref10.saleFrom) ? "INFORMATION_AND_BUY" : "INFORMATION"
                                    },
                                    type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_HORIZONTAL_SMALL */.I.BASIC_CARD_HORIZONTAL_SMALL,
                                    redirectUrl: (0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)(variant.productName, variant.title, variant.productId, variant.id)
                                })
                            }, variant.id);
                        })) !== null && ref4 !== void 0 ? ref4 : []
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, {
                        type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_HORIZONTAL_SMALL */.I.BASIC_CARD_HORIZONTAL_SMALL,
                        items: (ref5 = filteredVariants === null || filteredVariants === void 0 ? void 0 : (ref2 = filteredVariants.map) === null || ref2 === void 0 ? void 0 : ref2.call(filteredVariants, function(variant) {
                            var ref, ref11, ref12, ref13, ref14;
                            var _id;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_card/* default */.Z, {
                                media: {
                                    mediaUrl: (ref = variant.coverArt) === null || ref === void 0 ? void 0 : ref.url,
                                    initialLoad: true,
                                    contentType: (ref11 = variant.coverArt) === null || ref11 === void 0 ? void 0 : ref11.contentContentType,
                                    profilePictureUrl: variant.originatorsIds && variant.originatorsIds.length > 0 ? variant.originatorsIds[0] : undefined,
                                    posterUrl: (0,creatoken_posterUrl_resolver/* creatokenPosterUrlResolver */.m)((_id = variant.id) !== null && _id !== void 0 ? _id : -1),
                                    isTeaser: true
                                },
                                category: enum_to_language_mapper/* EnumToLanguageMapper.categoryIdToCategoryEnum */.H.categoryIdToCategoryEnum(variant.categoryId),
                                type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_HORIZONTAL_SMALL */.I.BASIC_CARD_HORIZONTAL_SMALL,
                                redirectUrl: (0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)(variant.productName, variant.title, variant.productId, variant.id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(variant_card, {
                                    variantId: variant.id,
                                    text: {
                                        headline: variant.title,
                                        topline: variant.originatorsNames ? variant.originatorsNames[0] : "",
                                        description: variant.variantDescriptionShort
                                    },
                                    footer: {
                                        onPrimaryAction: function() {
                                            return undefined;
                                        },
                                        actionType: variant.purchasableInstances > 0 || ((ref12 = variant.salesAttribute) === null || ref12 === void 0 ? void 0 : ref12.salesType) === sales_type/* SalesType.T_DROP */.r.T_DROP && !(0,time_helper/* isDateInPast */.OF)((ref13 = variant.salesAttribute) === null || ref13 === void 0 ? void 0 : ref13.saleTo) && (0,time_helper/* isDateInPast */.OF)((ref14 = variant.salesAttribute) === null || ref14 === void 0 ? void 0 : ref14.saleFrom) ? "INFORMATION_AND_BUY" : "INFORMATION"
                                    },
                                    type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_HORIZONTAL_SMALL */.I.BASIC_CARD_HORIZONTAL_SMALL,
                                    redirectUrl: (0,generate_url_to_details_page_helper/* generateUrlToDetailedPage */.e)(variant.productName, variant.title, variant.productId, variant.id)
                                })
                            }, variant.id);
                        })) !== null && ref5 !== void 0 ? ref5 : []
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (digital_originals_stage_module_default()).decButtonContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(creatoken_svg/* default */.Z, {})
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/utils/_enums/sorting-options.enum.tsx
var sorting_options_enum = __webpack_require__(77923);
// EXTERNAL MODULE: ./src/components/_shared/select/select.tsx
var select_select = __webpack_require__(39382);
// EXTERNAL MODULE: ./src/components/digital-originals/upper-filter/upper-filter.module.scss
var upper_filter_module = __webpack_require__(58273);
var upper_filter_module_default = /*#__PURE__*/__webpack_require__.n(upper_filter_module);
;// CONCATENATED MODULE: ./src/components/digital-originals/upper-filter/upper-filter-digital-originals.tsx









var UpperFilterDigitalOriginals = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var data = useDigitalOriginalsPage();
    var ref = (0,index_esm/* useForm */.cI)({
        mode: "onTouched"
    }), control = ref.control, setValue = ref.setValue;
    var sorting = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.productSlice.allVariantsSorting;
    });
    (0,react.useEffect)(function() {
        setValue("categoryId", sorting);
    }, [
        sorting
    ]);
    if (data) {
        var ref1, ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (upper_filter_module_default())["upper-filter"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (upper_filter_module_default())["sort-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, {
                    control: control,
                    label: (ref1 = data.sortBy) === null || ref1 === void 0 ? void 0 : ref1.fieldLabel,
                    placeholder: (ref2 = data.sortBy) === null || ref2 === void 0 ? void 0 : ref2.fieldHint,
                    onChange: function(value) {
                        return dispatch((0,redux/* updateAllVariantsSorting */.FW)(value.value));
                    },
                    name: "categoryId",
                    options: [
                        {
                            value: sorting_options_enum/* SortingOptionsEnum.TITLE_ASC */.R.TITLE_ASC,
                            label: data.sortByAlphabetAsc
                        },
                        {
                            value: sorting_options_enum/* SortingOptionsEnum.TITLE_DESC */.R.TITLE_DESC,
                            label: data.sortByAlphabetDesc
                        },
                        {
                            value: sorting_options_enum/* SortingOptionsEnum.DATE_ASC */.R.DATE_ASC,
                            label: data.sortByReleaseAsc
                        },
                        {
                            value: sorting_options_enum/* SortingOptionsEnum.DATE_DESC */.R.DATE_DESC,
                            label: data.sortByReleaseDesc
                        }, 
                    ]
                })
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var upper_filter_digital_originals = (UpperFilterDigitalOriginals);

;// CONCATENATED MODULE: ./src/components/digital-originals/variants-teaser/variants-teaser.tsx












var VariantsTeaser = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var data1 = useDigitalOriginalsPage();
    var variants = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.productSlice.allVariants;
    });
    var sorting = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.productSlice.allVariantsSorting;
    });
    (0,react.useEffect)(function() {
        fetchVariantsWithFilter(variants.pagination.page, 24);
    }, [
        sorting
    ]);
    var getSorting = function(value) {
        switch(value){
            case sorting_options_enum/* SortingOptionsEnum.TITLE_ASC */.R.TITLE_ASC:
                return {
                    value: "title,asc",
                    param: "sort",
                    comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                };
            case sorting_options_enum/* SortingOptionsEnum.TITLE_DESC */.R.TITLE_DESC:
                return {
                    value: "title,desc",
                    param: "sort",
                    comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                };
            case sorting_options_enum/* SortingOptionsEnum.DATE_ASC */.R.DATE_ASC:
                return {
                    value: "salesAttribute.saleFrom,asc",
                    param: "sort",
                    comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                };
            case sorting_options_enum/* SortingOptionsEnum.DATE_DESC */.R.DATE_DESC:
                return {
                    value: "salesAttribute.saleFrom,desc",
                    param: "sort",
                    comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                };
            default:
                return {
                    value: "salesAttribute.saleFrom,desc",
                    param: "sort",
                    comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
                };
        }
    };
    var fetchVariantsWithFilter = function(page, size) {
        var sortingObject = getSorting(sorting);
        dispatch((0,redux/* fetchVariants */.I_)([
            {
                value: size.toString(),
                param: "size",
                comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
            },
            {
                value: page.toString(),
                param: "page",
                comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
            },
            {
                value: "0",
                param: "mintingCount",
                comparisonType: filter_expression_enum/* FilterExpression.greaterThan */.p.greaterThan
            },
            {
                value: encodeURIComponent((0,time_helper/* dateToISOString */.CI)(new Date())),
                param: "saleFrom",
                comparisonType: filter_expression_enum/* FilterExpression.lessThan */.p.lessThan
            },
            sortingObject
        ]));
    };
    if (data1 && (variants === null || variants === void 0 ? void 0 : variants.data) && variants.data.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser/* default */.Z, {
                headline: data1.variantListHeadline.headlineContent,
                maxCards: variants.maxNumber,
                headlineElement: "h2",
                withNumbers: true,
                initialCardIndex: variants.pagination.page,
                hideTeaserButtons: true,
                pending: variants.pending,
                pagination: variants.pagination,
                cards: variants.data.map(function(variant) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card/* default */.Z, {
                        variant: variant
                    }, "variant-".concat(variant.id));
                }),
                onLoadNewItems: function(data) {
                    fetchVariantsWithFilter(data.pageOrOffset, data.size);
                },
                type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_SMALL */.I.BASIC_CARD_SMALL
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var variants_teaser = (VariantsTeaser);

;// CONCATENATED MODULE: ./src/views/digital-originals/digital-originals.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













var DigitalOriginals = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var data = useDigitalOriginalsPage();
    var ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(header_footer_wrapper/* HeaderFooterWrapper */.u, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(default_header/* DefaultHeader */.y, {
            availableLanguages: data === null || data === void 0 ? void 0 : data.localizations
        }),
        stage: /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitalOriginalsStage, {
            background: data === null || data === void 0 ? void 0 : (ref = data.stage) === null || ref === void 0 ? void 0 : (ref1 = ref.background) === null || ref1 === void 0 ? void 0 : ref1.url,
            title: (ref8 = data === null || data === void 0 ? void 0 : (ref2 = data.stage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.headline) === null || ref3 === void 0 ? void 0 : ref3.headlineContent) !== null && ref8 !== void 0 ? ref8 : "",
            titleVariant: data === null || data === void 0 ? void 0 : (ref4 = data.stage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.headline) === null || ref5 === void 0 ? void 0 : ref5.style,
            inverted: (ref9 = data === null || data === void 0 ? void 0 : (ref6 = data.stage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.componentStyles) === null || ref7 === void 0 ? void 0 : ref7.inverted) !== null && ref9 !== void 0 ? ref9 : false
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta_tags_resolver/* MetaTagsResolver */.H, {
                tags: data === null || data === void 0 ? void 0 : data.meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(upper_filter_digital_originals, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(coming_soon_teaser, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(variants_teaser, {})
        ]
    });
};
DigitalOriginals.dataHooks = [
    useLoginPage_hook/* useLoginPage */.Y,
    useAccountManageWallet_hook/* useAccountManageWallet */.Z,
    useDigitalOriginalsPage,
    useContextSSr_hook/* useContextSsr */._
].concat(_toConsumableArray(meta_tags_resolver/* MetaTagsResolver.dataHooks */.H.dataHooks));
/* harmony default export */ var digital_originals = (DigitalOriginals);

;// CONCATENATED MODULE: ./src/pages/digital-originals.tsx

var __N_SSP = true;
/* harmony default export */ var pages_digital_originals = (digital_originals);


/***/ }),

/***/ 70808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ creatokenPosterUrlResolver; }
/* harmony export */ });
var creatokenPosterUrlResolver = function(variantId) {
    switch(variantId){
        case 361:
            {
                return "https://images.creatokia.com/technical/creatoken/0.jpg";
            }
        case 360:
            {
                return "https://images.creatokia.com/technical/creatoken/1.jpg";
            }
        case 359:
            {
                return "https://images.creatokia.com/technical/creatoken/2.jpg";
            }
        case 358:
            {
                return "https://images.creatokia.com/technical/creatoken/3.jpg";
            }
        case 357:
            {
                return "https://images.creatokia.com/technical/creatoken/4.jpg";
            }
        case 356:
            {
                return "https://images.creatokia.com/technical/creatoken/5.jpg";
            }
        default:
            {
                return "";
            }
    }
};


/***/ }),

/***/ 72132:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","carousel-wrapper":"carousel_carousel-wrapper__e12pG","carousel-dots":"carousel_carousel-dots__d3_l5","inverted":"carousel_inverted__hvPWZ","basic-card-horizontal-small":"carousel_basic-card-horizontal-small__e7J_d","carousel-container":"carousel_carousel-container__rfEte","carousel-item":"carousel_carousel-item__Hr4h4","variant-detail":"carousel_variant-detail__XigTv"};

/***/ }),

/***/ 48106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stage-background":"stage-image-background_stage-background__OC_4p"};

/***/ }),

/***/ 35890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","variant-card-wrapper":"variant-card_variant-card-wrapper__J9Reg","teaser-card-text":"variant-card_teaser-card-text__nFCZz","optional-info":"variant-card_optional-info__Y_Fvp","basic-card-horizontal-small":"variant-card_basic-card-horizontal-small__oHijO"};

/***/ }),

/***/ 99375:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","stage":"digital-originals-stage_stage__oxDdK","stage-content":"digital-originals-stage_stage-content__x5UPE","title":"digital-originals-stage_title__2wg_O","inverted":"digital-originals-stage_inverted__UV1CW","decButtonContainer":"digital-originals-stage_decButtonContainer__5XDdG"};

/***/ }),

/***/ 58273:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","sort-wrapper":"upper-filter_sort-wrapper__9IPS9"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4577,9866,6586,8760,6067,3089,855,725,6188,2888,179], function() { return __webpack_exec__(40352); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);